<svelte:options customElement="individual-invoices-main" />

<script>
	import { onMount } from "svelte";
	import { loadAssets, baseUrl } from "../../../../../SharedSvelte/Common.svelte";
	import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import { individualInvoicesState } from "../../state/ApplicationState.svelte";
	import GlobalLoader from "../../../../../SharedSvelte/GlobalLoader.svelte";	
	import IndividualInvoices from './IndividualInvoices.svelte';

    let filterOptionsPromise;

    async function fetchFilterOptions() {
        Loader.display();
        
        try {
            const response = await fetch(`${baseUrl}Options/IndividualInvoices/FilterOptions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value
                }
            });

            window.scrollTo(0, 0);

            if (!response.ok) {
                const error = `Server exception: ${response.status} ${response.statusText}`;
                //prompt.showMessage(error, "Information");
                throw new Error(error);
            }

            const data = await response.json();
            individualInvoicesState.beginningDate = data.beginningDate.split("T")[0];
            individualInvoicesState.endingDate = data.endingDate.split("T")[0];

            return data; // Resolves the Promise with the fetched data
        } catch (error) {
            console.error("Error fetching filter options:", error);
            return Promise.reject(error); // Rejects the Promise with the error
        } finally {
            Loader.hide();
        }
    }

	onMount(() => {
		setTimeout(() => {
		loadAssets("individual-invoices-main");
		}, 10);
        filterOptionsPromise = 
            fetchFilterOptions()
            .then(filterData => {
                // console.log("options loaded:", filterData);
            });
	});
</script>

{#await filterOptionsPromise}
    <div>Loading...</div>
{:then data}
    <!-- <pre>{JSON.stringify(data)}</pre> -->
    
    <IndividualInvoices />
    
<!-- {:catch error}
    <div class="text-danger">{error}</div> -->
{/await}

<GlobalLoader />